// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input--voice {
    border-radius: 12px;
    background-color: #006480;
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 14px;
    top: -26px;
    cursor: pointer;
}

.input--voice > img {
    cursor: pointer;
    width: 24px;
}

.listening {
    width: 16px;
    height: 16px;
    background: white;
}`, "",{"version":3,"sources":["webpack://./src/components/AudioRecorder/AudioRecorder.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".input--voice {\n    border-radius: 12px;\n    background-color: #006480;\n    width: 55px;\n    height: 55px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: 14px;\n    top: -26px;\n    cursor: pointer;\n}\n\n.input--voice > img {\n    cursor: pointer;\n    width: 24px;\n}\n\n.listening {\n    width: 16px;\n    height: 16px;\n    background: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
